import React, { useEffect } from 'react';
import './styles/AnimatedDiv.css';

function JourneySectionIntro() {
    useEffect(() => {
        const textBox = document.querySelector('#journeysectionintrotext.animateddiv');
        if (!textBox) return;

        const isCoarse = window.matchMedia('(pointer: coarse)').matches;
        const viewActivationOffset = isCoarse ? 125 : 0;

        function animateTextBox() {
            const textBoxPosition = textBox.getBoundingClientRect();
            if (textBoxPosition.top >= 0 && textBoxPosition.bottom <= window.innerHeight + viewActivationOffset) {
                textBox.classList.add('active');
                textBox.classList.remove('hidden');
            }
        }

        document.addEventListener('scroll', animateTextBox);
        return () => {
            document.removeEventListener('scroll', animateTextBox);
        };
    }, []);

    return (
        <div>
            <div className="section-divider">
                <div className="bracket left">
                    <span className="tag">// SECTION_02</span>
                    <div className="line"></div>
                </div>
                <h1 id="myjourney" className="defaultlargeWithBanner">My Journey</h1>
                <div className="bracket right">
                    <div className="line"></div>
                    <span className="tag">[ ARCHIVE ]</span>
                </div>
            </div>

            <div id="journeysectionintrotext" className="animateddiv">
                <div className="middleContainerLarge defaulttext">
                    <p className="defaulttext" align="justify">From the dark skies of Oslo to the tech dreams of Seattle, I've sought out new challenges.
                    Each country I've called home represents a distinct chapter of my life, with unique experiences, projects and learnings to look back on.
                    You can view each of these chapters below.
                    </p>

                    <h3 className="scroll-cue">
                        <span className="cue-arrow desktop-only">↓</span>
                        <span className="cue-arrow mobile-only">↔</span>
                        <span className="cue-text desktop-only">Change flag to scroll</span>
                        <span className="cue-text mobile-only">Swipe to scroll</span>
                        <span className="cue-arrow desktop-only">↓</span>
                        <span className="cue-arrow mobile-only">↔</span>
                    </h3>
                </div>
            </div>
        </div>
    );
}

export default JourneySectionIntro;
